import React from 'react';
import { styled } from '@mui/material/styles';
import {
  BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar, Label
} from 'recharts';
import { Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material';
import "../../styles/rechartsOverride.css";


const PREFIX = 'ChartComponent';

const classes = {
  container: `${PREFIX}-container`,
  title: `${PREFIX}-title`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.container}`]: {
    marginLeft: '50px',
    marginRight: '50px',
    marginBottom: '50px',
    paddingBottom: '20px',
    paddingTop: '20px',
    maxHeight: '100%',
  },

  [`& .${classes.title}`]: {
    textAlign: "center"
  }
}));

function ChartComponent(props) {

  const {
    data,
    title,
    xtitle,
    ytitle,
    minValue,
    maxValue,
    legendData,
    height,
    width,
    chartType,
    barWidth
  } = props;

  //mobile support
  const theme = useTheme();
  const mdCheck = useMediaQuery(theme.breakpoints.down('md'));
  const lgCheck = useMediaQuery(theme.breakpoints.down('lg'));
  const xsCheck = useMediaQuery(theme.breakpoints.down('xs'));
  /*
  console.log("mdCheck: "+mdCheck);
  console.log("lgCheck: "+lgCheck);
  console.log("xsCheck: "+xsCheck);
  console.log("width: "+width);
  */
  var widthScreen = 0.7 * width;;
  var verticalAlign = "top";
  var align = "right";
  var layout = "vertical";
  var chartViewMarginRight = 0;
  if (lgCheck){
    widthScreen = 0.88 * width;
    verticalAlign="top";
    align="center";
    layout="horizontal";
  }
  //console.log("widthScreen: "+widthScreen);
  if (xsCheck)
    chartViewMarginRight = 50;
    
  const heightScreen = 0.65 * height * 1;
  var temp = 75;
  var xaxiIndexShowed = 0;
  const labelFontSize = height < 700 ? 14 : 16; //adjust the font of the x and y axis titles
  const XAxisTickFontSize = 11; //adjust the font of the xaxis labels
  const tooltipFontSize = 12; // fontsize of the text in the details box
  const legendFontSize = 12; //size of the chart legend

  var barComponent = [];
  for (var i = 0; i < legendData.length; i++) {
    switch (chartType) {
      case ("simplebar"):
        barComponent.push(<Bar dataKey={legendData[i].name} fill={legendData[i].color} key={i} />);
        break;
      case ("stackedbar"):
        barComponent.push(<Bar dataKey={legendData[i].name} stackId="a" fill={legendData[i].color} key={i} />);
        break;
      case ("mixbar"):
        barComponent.push(<Bar dataKey={legendData[i].name} stackId={legendData[i].stackId} fill={legendData[i].color} key={i}/>)
      default:
        break;
    }
  }

  //Cantidad de valores a mostrar en navegador Eje X
  var brushComponent = null;
  if (data.length * legendData.length > 30) {
    xaxiIndexShowed = Math.trunc(30 / legendData.length);
  }
  else {
    xaxiIndexShowed = data.length - 1;
  }

  //var brushComponent = data.length === 1 ? null: <Brush dataKey='xaxi' travellerWidth={5} height={20} endIndex={xaxiIndexShowed} stroke="#4ABDAC" />;
  brushComponent = null;
  var offsetXaxis = brushComponent === null ? 0 : 40; //Si existe la componente Brush, se deja espacio para título de Eje X

  //barSize es seguido a menos que el tamaño eleguido no permita deplegar toda la data donde ara las barras 
  //lo mas grandes posibles para complir con los margenes dispuestos y mostrar toda la data.

  return (
    <Root>
      <Typography className={classes.title} variant="h6">{title}</Typography>
      <BarChart width={widthScreen} height={heightScreen} data={data} barGap={'3%'} barSize={barWidth} margin={{ top: 30, right: chartViewMarginRight, left: 30, bottom: 50 }}>
      
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis scale="auto" dataKey="xaxi" layout="vertical" angle={-40} textAnchor="end" tick={{ fontSize: XAxisTickFontSize }} interval={0} height={temp} width={40} >
          <Label fill={'#212121'} value={xtitle} offset={offsetXaxis} position="bottom" fontSize={labelFontSize} />
        </XAxis>
        <YAxis type="number" label={{ fill:'#212121', value: ytitle, angle: -90, position: 'insideLeft', fontSize: labelFontSize, offset: 15, style: { textAnchor: 'middle' } }} domain={[minValue, maxValue]} />
        {mdCheck ? 
          null :
          <Tooltip itemStyle={{ paddingBottom: 0, fontSize: tooltipFontSize }} coordinate={{ x: 10, y: 0 }} />
        }
        <Legend verticalAlign={verticalAlign} align={align} layout={layout} wrapperStyle={{ paddingBottom: "10px", paddingLeft: "10px", fontSize: legendFontSize }} />
        {barComponent}
        {brushComponent}
      </BarChart>
    </Root>
  );
}

export default ChartComponent;

